"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Executor(props) {
    var data = props.hook();
    props.onUpdate(data);
    return null;
}
exports.Executor = Executor;
